export function switch_(ctx) {
    return {
        // No per-state overrides: firmware's pretty/pretty_color/sw_knob styles
        // (lv_theme_hasp.c) only ever set LV_STATE_DEFAULT for switch's 3 parts.
        styles: {
            main:      { bg_color: ctx.COLOR_BG_SEC, bg_opa: 255, radius: 999, border_width: 0 },
            // indicator = bar_indic. border_width: 0 added — firmware's bar_indic sets no
            // border at all, but the schema's own HASP-theme default (border_width: 2) would
            // otherwise leak through unmasked for this Material-styled theme (same fix as
            // slider.js's indicator/knob).
            indicator: { bg_color: ctx.primary, radius: 999, border_width: 0 },
            // knob = sw_knob. Firmware's real knob padding is negative (-LV_DPX(4), the knob
            // circle overhangs the track — lv_theme_material.c:442-445), which the schema
            // cannot represent (knob.padding has `min: 0`) — no clean way to express this at
            // the theme layer; a schema-level gap, not fixed here.
            knob:      { bg_color: '#ffffff', radius: 999, border_width: 0 },
        },
    };
}
